import React from "react"
import { Paper, CircularProgress, FloatingActionButton, SelectField, MenuItem, RaisedButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { IJobSearch, IUserFilterDocument, EDefaultFilterValues, ISelectedFilterTemplateId, IJobDocument, IMassJobEdit, IJobReportParameters, IJobReportColumns, IJobFilter } from "../../models"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import * as api from "../../api"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import TableActionBar from "../../components/layout/TableActionBar"
import JobsTable from "./JobsTable"
import { browserHistory } from "react-router"
import AddJobDialog from "./AddJobDialog"
import JobMassShiftEditDialog from "./JobMassShiftEditDialog"
import * as reportAction from "../../actions/ReportAction"
import * as jobHelper from "../../helpers/jobHelper"
import * as permissionHelper from "../../helpers/permissionHelper"
import { debounce } from "lodash"
import JobFilter from "../../components/filter_template/job/JobFilter"
import moment from "moment"
import JobsViewBudgetDrawer from "../../components/job/multi_job_budget/JobsViewBudgetDrawer"
interface IState {
  jobs: IJobDocument[]
  selectedJobs: IJobDocument[]
  showActiveJob: boolean
  searchText: string
  loading: boolean
  total: number
  offset: number
  limit: number
  openAddJobDialog: boolean
  openMassEditDialog: boolean
  jobColumns: IJobReportColumns
  filterOnlyFavorites: boolean
  selectedFilterTemplateId: ISelectedFilterTemplateId
  filterTemplates: IJobFilter[]
  openBudgetDrawer: boolean
}

export default class Jobs extends React.Component<any, IState> {
  private JobFilters: { userId: string; active: boolean; filterOnlyFavorites: boolean }[] = localStorage.getItem("JobFilters") ? JSON.parse(localStorage.getItem("JobFilters")) : null
  private SelectedJobFilter = this.JobFilters && this.JobFilters.find(x => x.userId === AuthenticationStore.getLoggedInUser().Id) ? this.JobFilters.find(x => x.userId === AuthenticationStore.getLoggedInUser().Id) : null
  constructor(props) {
    super(props)
    const jobColumns: IJobReportColumns = localStorage.getItem("JobColumns") ?
      JSON.parse(localStorage.getItem("JobColumns")) :
      {
        IncludeName: true,
        IncludeParentHierarchy: true,
        IncludeJobId: true,
        IncludeShifts: AccountStore.getCRMEnabled() && AccountStore.getScheduleEnabled(),
        IncludePhases: AccountStore.getPhasesEnabled(),
        IncludeActive: true
      }
    if (!AccountStore.getCRMEnabled() || !AccountStore.getScheduleEnabled())
      jobColumns.IncludeShifts = false
    if (!AccountStore.getPhasesEnabled())
      jobColumns.IncludePhases = false

    this.state = {
      jobs: [],
      selectedJobs: [],
      showActiveJob: this.SelectedJobFilter ? this.SelectedJobFilter.active : true,
      searchText: "",
      loading: false,
      total: 0,
      offset: 0,
      limit: 20,
      openAddJobDialog: false,
      openMassEditDialog: false,
      jobColumns: localStorage.getItem("JobColumns") ? JSON.parse(localStorage.getItem("JobColumns")) :
        {
          IncludeName: true,
          IncludeParentHierarchy: true,
          IncludeJobId: true,
          IncludeShifts: true,
          IncludePhases: true,
          IncludeActive: true
        },
      filterOnlyFavorites: this.SelectedJobFilter ? this.SelectedJobFilter.filterOnlyFavorites : false,
      selectedFilterTemplateId: EDefaultFilterValues.NONE,
      filterTemplates: [],
      openBudgetDrawer: false,
    }
    autobind(this)
  }

  componentDidMount() {
    document.title = `${strings.Jobs} | ${strings.Findd_Grandd_Central}`
    HierarchySettingsStore.on("global_change", this.getJobs)
    this.getJobsAndFilters()
  }

  componentWillUnmount() {
    HierarchySettingsStore.removeListener("global_change", this.getJobs)
  }

  getJobsAndFilters() {
    this.setState({ loading: true }, () =>
      api.getFilters(AuthenticationStore.getLoggedInUser().Id).then(res => {
        const result = res.data as IUserFilterDocument
        const selectedFilterTemplateId = result && result.SelectedJobFilter ? result.SelectedJobFilter : EDefaultFilterValues.NONE
        const filterTemplates = result && result.JobFilters ? result.JobFilters : []
        this.setState({ filterTemplates, selectedFilterTemplateId }, () => this.getJobs())
      })
    )
  }

  reloadJobsTable() {
    this.getJobs()
  }

  getJobs() {
    this.state.selectedFilterTemplateId !== EDefaultFilterValues.CREATE_NEW &&
      this.setState({ loading: true }, () => {
        api.searchJobs(AccountStore.getCurrentAccount().Id, this.state.offset / this.state.limit, this.state.limit, this.getJobFilterData())
          .then(res => {
            const data = res.data as IJobSearch
            this.setState({
              loading: false,
              total: data.TotalDocumentCount,
              jobs: data.Documents,
              selectedJobs: [],
            })
          })
      })
  }

  getJobFilterData(): IJobFilter {
    const selectedFilterTemplate = this.state.filterTemplates.find(i => i.Id === this.state.selectedFilterTemplateId)
    let hierarchyItemId = HierarchySettingsStore.getGlobalLevelItemFilterId()
    if (hierarchyItemId === "null") hierarchyItemId = null
    let jobFilter: IJobFilter = selectedFilterTemplate ||
      {
        Active: this.state.showActiveJob,
        FilterOnlyFavorites: this.state.filterOnlyFavorites
      } as IJobFilter
    jobFilter = {
      ...jobFilter,
      Search: this.state.searchText,
      HierarchyItemId: hierarchyItemId,
      Today: moment().startOf("day").utc(true).format()
    } as IJobFilter
    return jobFilter
  }

  getJobsDataDownload() {
    const jobReportParams = {
      Page: 0,
      Limit: this.state.total,
      JobFilter: this.getJobFilterData(),
      ReportColumns: this.state.jobColumns
    } as IJobReportParameters
    reportAction.downloadJobsData(AccountStore.getCurrentAccount().Id, jobReportParams)
  }

  onSearchChange = debounce(searchText => {
    this.setState({ searchText, offset: 0 }, () => this.getJobs())
  }, 1000)

  saveMassEditData(data: IMassJobEdit) {
    this.setState({ openMassEditDialog: false, selectedJobs: [] }, () => {
      api.saveMassEditJobData(data).then(res => this.getJobs())
    })
  }

  saveJobFilters(active: boolean, filterOnlyFavorites: boolean) {
    if (this.JobFilters) {
      if (this.SelectedJobFilter) {
        const jobFilters = this.JobFilters
        jobFilters[this.JobFilters.indexOf(this.SelectedJobFilter)].active = active
        jobFilters[this.JobFilters.indexOf(this.SelectedJobFilter)].filterOnlyFavorites = filterOnlyFavorites
        localStorage.setItem("JobFilters", JSON.stringify(jobFilters))
      }
      else {
        const selectedFilter = { userId: AuthenticationStore.getLoggedInUser().Id, active, filterOnlyFavorites }
        localStorage.setItem("JobFilters", JSON.stringify([...this.JobFilters, selectedFilter]))
      }
    }
    else {
      const selectedFilter = { userId: AuthenticationStore.getLoggedInUser().Id, active, filterOnlyFavorites }
      localStorage.setItem("JobFilters", JSON.stringify([selectedFilter]))
    }
  }

  render() {
    return (
        <div className="page-container">
            <div className="page-container-parent">
                {jobHelper.getAllowJobByHierarchy(HierarchySettingsStore.getGlobalLevelItemFilterId()) && permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.AddJobs) &&
                    <FloatingActionButton data-intercom-target={"menu-Jobs-Btn-Add"} className="fixed-add" style={{ top: 83, right: 40, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ openAddJobDialog: true })}>
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <Paper zDepth={1} className="page-paper">
                    <TableActionBar
                        rowSelectionCount={this.state.selectedJobs.length}
                        singleSelectedMessage={strings.Job_Selected}
                        multipleSelectedMessage={strings.x_Job_Selected}
                        title={jobHelper.checkJobFieldAvailable("plural") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel : strings.Jobs}
                        onSearch={(searchText) => this.onSearchChange(searchText)}
                        reloadTable={this.reloadJobsTable}
                        exportTable={this.getJobsDataDownload}
                        searchText={this.state.searchText}
                        onEditSelectedItem={() =>
                            this.state.selectedJobs.some(x => x.NumberOfShifts > 1) ?
                  AppStateStore.setProgressSnackbarContent(strings.Shift_Edit_Error_Message) :
                  this.setState({ openMassEditDialog: true })
                        }
                        onDeleteClick={() => {
                            const deleteJobIds = this.state.selectedJobs.map(i => i.Id)
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.allowDeleteOrInactiveJobs(deleteJobIds).then(res => {
                                AppStateStore.setProgressSnackbarContent(null)
                                res.data ?
                    AppStateStore.setConfirmDialogContent({
                                          content: strings.Are_you_sure_you_want_to_delete_the_selected_job,
                                          confirm: () => {
                                              AppStateStore.setProgressSnackbarContent("loading")
                                              api.deleteJobs(deleteJobIds)
                                                  .then(() => {
                                                      AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                                                      this.getJobs()
                                                  })
                                                  .catch(e =>
                            AppStateStore.setProgressSnackbarContent(e.response.data.message)
                          )
                                          }
                                      }) :
                    AppStateStore.setAlertDialogContent({
                                          title: strings.Cannot_Delete_Job,
                                          content: strings.Cannot_Delete_Job_because_it_is_already_use
                                      })
                            })
                        }}
                        readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.DeleteJobs)}
                    />
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <JobFilter
                            filterTemplates={this.state.filterTemplates}
                            selectedFilterTemplateId={this.state.selectedFilterTemplateId}
                            handleChangeFilterTemplates={filterTemplates => this.setState({ filterTemplates })}
                            handleSelectFilterTemlate={filterId =>
                                this.setState({ selectedFilterTemplateId: filterId }, () => {
                                    api.setSelectedJobFilter(AuthenticationStore.getLoggedInUser().Id,
                                        (filterId === EDefaultFilterValues.NONE || filterId === EDefaultFilterValues.CREATE_NEW) ? "" : filterId as string
                                    )
                                    this.getJobs()
                                })
                            }
                        />
                        <div style={{ display: "flex" }}>
                            <div style={{ marginRight: 45, marginTop: 13 }}>
                                <RaisedButton
                                    data-intercom-target={"Jobs-ViewBudget-Btn"}
                                    secondary
                                    disabled={this.state.loading}
                                    label={strings.View_Budget}
                                    onTouchTap={() => this.setState({ openBudgetDrawer: true })}
                                />
                            </div>
                            {(this.state.selectedFilterTemplateId === EDefaultFilterValues.NONE || this.state.selectedFilterTemplateId == EDefaultFilterValues.CREATE_NEW) &&
                                <SelectField
                                    data-intercom-target={"menu-Jobs-Filter-Select-ActiveStatus"}
                                    floatingLabelText={strings.Job_Filter}
                                    floatingLabelFixed
                                    value={this.state.showActiveJob}
                                    onChange={(event, key, showActiveJob) => {
                                        this.setState({ showActiveJob, filterOnlyFavorites: showActiveJob === null ? true : false }, () => {
                                            this.saveJobFilters(showActiveJob, this.state.filterOnlyFavorites)
                                            this.getJobs()
                                        })
                                    }}
                                    style={{ marginRight: 25, marginTop: -15, marginBottom: -10, width: 250 }}
                                >
                                    <MenuItem value={true} primaryText={strings.Active} />
                                    <MenuItem value={false} primaryText={strings.Inactive} />
                                    <MenuItem value={null} primaryText={strings.Favorites} />
                                </SelectField>
                            }
                        </div>
                    </div>
                    <div style={{ padding: 20 }}>
                        {this.state.loading ?
                            <div className="spinner"><CircularProgress /></div> :
                            <div>
                                {!this.state.jobs.length ?
                                    <h2 style={{ textAlign: "center", marginTop: 25 }}>
                      {strings.No_job_found}
                    </h2> :
                                    <JobsTable
                                        readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.DeleteJobs)}
                                        jobs={this.state.jobs}
                                        selectedJobs={this.state.selectedJobs}
                                        total={this.state.total}
                                        offset={this.state.offset}
                                        limit={this.state.limit}
                                        limitOptions={[20, 50, 100]}
                                        onPageClick={offset => this.setState({ offset }, () => this.getJobs())}
                                        onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getJobs())}
                                        handleClickRow={jobId => browserHistory.replace(`/job-details/${jobId}`)}
                                        handleSelectJobs={selectedJobs => this.setState({ selectedJobs })}
                                        jobColumns={this.state.jobColumns}
                                        tableColumnSelect={[
                                            { label: strings.Name, show: true, value: this.state.jobColumns.IncludeName, propertyName: "IncludeName" },
                                            { label: strings.Parent_Hierarchy, show: true, value: this.state.jobColumns.IncludeParentHierarchy, propertyName: "IncludeParentHierarchy" },
                                            { label: strings.Job_ID, show: true, value: this.state.jobColumns.IncludeJobId, propertyName: "IncludeJobId" },
                                            { label: strings.Shifts, show: AccountStore.getCRMEnabled() && AccountStore.getScheduleEnabled(), value: this.state.jobColumns.IncludeShifts, propertyName: "IncludeShifts" },
                                            { label: strings.Phases, show: AccountStore.getPhasesEnabled(), value: this.state.jobColumns.IncludePhases, propertyName: "IncludePhases" },
                                            { label: strings.Active, show: true, value: this.state.jobColumns.IncludeActive, propertyName: "IncludeActive" }
                                        ]}
                                        handleChangeTableColumns={columns => {
                                            const jobColumns = {} as IJobReportColumns
                                            columns.forEach(i => {
                                                jobColumns[i.propertyName] = i.value
                                            })
                                            this.setState({ jobColumns })
                                            localStorage.setItem("JobColumns", JSON.stringify(jobColumns))
                                        }}
                                    />
                                }
                            </div>
                        }
                    </div>
                </Paper>
            </div>
            {this.state.openAddJobDialog &&
                <AddJobDialog
                    handleAdd={job => {
                        this.setState({ openAddJobDialog: false })
                        AppStateStore.setProgressSnackbarContent("loading")
                        api.addJob(job)
                            .then(() => {
                                AppStateStore.triggerGetFreeAccountMetricsData()
                                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                                this.getJobs()
                            })
                            .catch(err =>
                                    (err.response.data.message) && (
                    err.response.data.message === "Cannot add over 10 jobs for free account." ?
                      AppStateStore.setFreeAccountDataLimitUpgradeDialogContent(strings.Cannot_add_over_10_jobs_for_free_account_Please_upgrade_your_account_plan_to_add_more) :
                      AppStateStore.setProgressSnackbarContent(err.response.data.message)
                  )
                            )
                    }}
                    handleClose={() => this.setState({ openAddJobDialog: false })}
                />
            }
            {this.state.openMassEditDialog &&
                <JobMassShiftEditDialog
            jobIds={this.state.selectedJobs.map(x => x.Id)}
            handleSaveMassEdit={this.saveMassEditData}
            onClose={() => this.setState({ openMassEditDialog: false })}
          />
            }
            <JobsViewBudgetDrawer
          open={this.state.openBudgetDrawer}
          jobsCount={this.state.total}
          jobFilter={this.getJobFilterData()}
          handleClose={() => this.setState({ openBudgetDrawer: false })}
        />
        </div>
    )
  }
}